"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var LinkCopiedIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 11", fill: "currentColor", width: size || '14', height: size || '11' }, props),
        React.createElement("path", { fill: "currentColor", d: "M3.59 9.782l.653.653 9.192-9.192-.979-.98-8.273 8.274L.919 5.273 0 6.193l3.59 3.59z", fillRule: "evenodd" })));
};
LinkCopiedIcon.displayName = 'LinkCopiedIcon';
exports.default = LinkCopiedIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LinkCopiedIcon.js.map